var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field",class:{
			'input': _vm.type !== 'textarea',
			'textarea': _vm.type === 'textarea',
			'input-prefix': this.$slots.prefix,
			'input-suffix': this.$slots.suffix,
			'input-prepend': this.$slots.prepend,
			'input-append': this.$slots.append,
			'focus':_vm.inputFocused,
			'value':_vm.value!==null && _vm.value!=='',
			'label':_vm.label
		}},[(_vm.$slots.default)?_c('span',{staticClass:"slot"},[_vm._t("default")],2):_vm._e(),_c('input',{staticClass:"inner",attrs:{"id":_vm.inputId,"name":_vm.name,"type":_vm.type,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"readonly":_vm.readonly,"max":_vm.max,"min":_vm.min,"tabindex":_vm.tabindex,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize},domProps:{"value":_vm.value},on:{"keyup":function($event){return _vm.$emit('keyup', $event)},"blur":_vm.onBlur,"focus":function($event){return _vm.$emit('focus')},"input":_vm.onInput}}),(_vm.$slots.suffix)?_c('div',{staticClass:"suffix"},[_vm._t("suffix")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }